export default (state = {}, {firstOrderId, order}: any) => {
  return {
    ...state,
    firstOrderDetail: {
      [firstOrderId]: order,
    },
  };
};
